module.exports = __webpack_public_path__ + "img/fullscreen-exit.36e61fb6.svg";